/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface StorageNodeStatus
 */
export interface StorageNodeStatus {
    /**
     * 
     * @type {boolean}
     * @memberof StorageNodeStatus
     */
    online: boolean;
    /**
     * 
     * @type {{ [key: string]: string | undefined; }}
     * @memberof StorageNodeStatus
     */
    report: { [key: string]: string | undefined; } | null;
    /**
     * 
     * @type {boolean}
     * @memberof StorageNodeStatus
     */
    haOnline: boolean | null;
    /**
     * 
     * @type {string}
     * @memberof StorageNodeStatus
     */
    haStatus: string | null;
    /**
     * 
     * @type {Array<string>}
     * @memberof StorageNodeStatus
     */
    haIps: Array<string>;
}

export function StorageNodeStatusFromJSON(json: any): StorageNodeStatus {
    return StorageNodeStatusFromJSONTyped(json, false);
}

export function StorageNodeStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): StorageNodeStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'online': json['online'],
        'report': json['report'],
        'haOnline': json['ha_online'],
        'haStatus': json['ha_status'],
        'haIps': json['ha_ips'],
    };
}

export function StorageNodeStatusToJSON(value?: StorageNodeStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'online': value.online,
        'report': value.report,
        'ha_online': value.haOnline,
        'ha_status': value.haStatus,
        'ha_ips': value.haIps,
    };
}


